// Reconciled against contract v1 (79487c2) section 6 - the cloud Functions bridge. The
// SignalR envelope is now SPECIFIED, not provisional: Azure SignalR serverless. Events
// arrive over SignalR (client method `telephonyFrame`); commands go over HTTP POST.

export const CloudRoutes = {
  /** POST ?siteGuid=  -> { url, accessToken } Azure SignalR connection info. */
  negotiate: '/stationbridge/negotiate',
  /** POST { site_guid, command, command_id?, params } -> CommandResponse. */
  command: '/stationbridge/command'
} as const

/** Azure SignalR hub name; the connection's userId is the SiteGuid (site receives only
 *  its own frames). */
export const HubName = 'stationbridge'

/** Client method the hub invokes on the browser - one coalesced telephony_frame per call. */
export const ClientMethod = { frame: 'telephonyFrame' } as const
